import {
  CircularProgress,
  FormControlLabel,
  Switch,
  Box,
  IconButton,
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";

import React, { useState, useRef } from "react";
import MissionModal from "../Controls/MissionModal";
import MUIDataTable from "mui-datatables";
import { useParams } from "react-router-dom";
import {
  getAllProcesses,
  deleteProcess,
} from "../../../Services/ProcessService";
import { terminerMission } from "../../../Services/MissionService";
import moment from "moment";
import AppointmentModal from "./Modals/CandidatProcess/AppointmentModal";
import SendCandidatToClientModal from "./Modals/CandidatProcess/SendCandidatToClientModal";
import AppointmentsListModal from "./Modals/CandidatProcess/AppointmentsListModal";
import "../visuialisation.css";
import { withSnackbar } from "../../../../utils/SnackbarHOC";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import DialogDeleteCustom from "../../../../components/DialogDeleteCustom/DialogDeleteCustom";
import { updateIntegrationDate, updateAppointment } from "../../../Services/AppointmentService";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { getRowData } from "../../../../utils/FunctionHelpers";

const Process = ({
  setAutresPieces,
  candidatName,
  candidatEmail,
  candidatTel,
  candidatAccountManager,
  candidatConsultant,
  candidatSeniorite,
  candidatCommentaire,
  candidatPointFort,
  candidatSoftskills,
  candidatLangue2,
  candidatAnglais,
  candidatActuPackage,
  candidatActuFixe,
  candidatActuVariable,
  candidatActuInteress,
  candidatSouhaitePackage,
  candidatsouhaiteFixe,
  candidatsouhaiteVariable,
  candidatsouhaiteInteress,
  candidatpreAvis,
  candidatdispoLe,
  numCandidat,
  snackbarShowMessage,
  ...rest
}) => {
  const useStyles = makeStyles(() => ({
    actionContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  }))
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const parametters = useParams();
  const idCandidat = rest.idCandidat ?? parametters.idCandidat;
  const [missionPassive, setMissionPassive] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [loadingtoFinish, setLoadingToFinish] = useState(false);
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [missionInfos, setMissionInfos] = useState({ id: "", nom: "" });
  const [openFinishDialog, setOpenFinishDialog] = useState(false);
  const missionModalProps = {
    processes,
    setReloadData,
    reloadData,
    snackbarShowMessage,
  };
  const apptModalProps = { reloadData, setReloadData };
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const isActive = useRef();

  const [dateModalOpen, setDateModalOpen] = useState(false);
  const [selectedDateIntegration, setSelectedDateIntegration] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [editingProcessId, setEditingProcessId] = useState(null);
  const [editingStep, setEditingStep] = useState(null);
  const [savingDate, setSavingDate] = useState(false);

  const handlePageChange = (page) => {
    setPage(page + 1);
  };

  const handleCloseFinishDialog = () => {
    if (!loadingtoFinish) {
      setOpenFinishDialog(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    if (!loadingToDelete) {
      setOpenDeleteDialog(false);
    }
  };

  const handleDeleteProcess = (e, processId, numMission) => {
    e.preventDefault();
    setMissionInfos({ id: processId, nom: numMission });
    setOpenDeleteDialog(true);
  };

  const handleFinishMission = () => {
    if (!loadingtoFinish) {
      setLoadingToFinish(true);
      (async () => {
        try {
          const { data } = await terminerMission(missionInfos.id);
          if (!isActive.current) {
            return;
          }
          snackbarShowMessage(data);
          setLoadingToFinish(false);
          handleCloseFinishDialog();
          setReloadData(!reloadData);
        } catch (error) {
          if (!isActive.current) {
            return;
          }
          snackbarShowMessage(error.response.data.error.detail, "error", 4000);
          setLoadingToFinish(false);
        }
      })();
    }
  };

  const deleteProcessFromCandidat = () => {
    (async () => {
      setLoadingToDelete(true);
      try {
        const { data } = await deleteProcess(missionInfos.id);
        if (!isActive.current) {
          return;
        }
        snackbarShowMessage(data);
        setLoadingToDelete(false);
        handleCloseDeleteDialog();
        setReloadData(!reloadData);
      } catch (error) {
        snackbarShowMessage(error.response.data.error.detail, "error", 4000);
        setLoadingToDelete(false);
      }
    })();
  };

  const handleOpenDateModal = (processId, currentDate, currentDateIntegration, step) => {
    setEditingProcessId(processId);
    setSelectedDate(currentDate ? new Date(currentDate) : new Date());
    setSelectedDateIntegration(
        currentDateIntegration ? new Date(currentDateIntegration) : null
    );
    setEditingStep(step);
    setDateModalOpen(true);
  };

  const handleCloseDateModal = () => {
    if (!savingDate) {
      setDateModalOpen(false);
      setSelectedDateIntegration(null);
      setEditingProcessId(null);
      setEditingStep(null);
    }
  };

  const handleSaveDateIntegration = () => {
    if (!editingProcessId || !selectedDate) return;
    (async () => {
      try {
        setSavingDate(true);

        // Mise à jour de la date principale (toujours)
        await updateAppointment({
          date: moment(selectedDate).format("YYYY-MM-DD"),
          processId: editingProcessId,
        });

        // Mise à jour de la date d'intégration (uniquement si Embauche/Integration)
        if (editingStep === "Embauche/Integration" && selectedDateIntegration) {
          await updateIntegrationDate({
            processId: editingProcessId,
            dateIntegration: moment(selectedDateIntegration).format("YYYY-MM-DD"),
          });
        }

        if (!isActive.current) return;
        snackbarShowMessage("La date a été modifiée avec succès.");
        setSavingDate(false);
        handleCloseDateModal();
        setReloadData(!reloadData);
      } catch (error) {
        if (!isActive.current) return;
        snackbarShowMessage(error.response.data.error.detail, "error", 4000);
        setSavingDate(false);
      }
    })();
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        setProcesses([]);
        const status = missionPassive
          ? "bad58bee-1b80-448c-9010-03cad8526233"
          : "910f357b-0b13-4f66-89a8-5c06964c1dcf";
        const newProccessesActive = await getAllProcesses(
          idCandidat,
          page,
          50,
          status
        );
        setProcesses(newProccessesActive.data.processes);
        setCount(newProccessesActive.data.count);
      } catch (error) {
        snackbarShowMessage(error.response.data.error.detail, "error", 4000);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, missionPassive, idCandidat, reloadData]);

  React.useEffect(() => {
    isActive.current = true;
    return () => {
      isActive.current = false;
    };
  });

  const columns = [
    {
      name: "missionId",
      label: "MISSION ID",
      options: {
        display: false,
      },
    },
    {
      name: "nom_societe",
      label: "SOCIETE",
      options: {
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "200px",
            padding: "0px 12px",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
            maxWidth: "200px",
            padding: "2px 12px",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <Box data-toggle="tooltip" title={value}>
              <Link
                to={{ pathname: `/societe/${row.societeId}/view` }}
                className="d-print-none font-sm"
                style={{ textDecoration: "none" }}
              >
                {value}
              </Link>
            </Box>
          );
        },
      },
    },
    {
      name: "statut",
      label: "STATUT",
      options: {
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "100px",
            padding: "0px 12px",
          },
        }),
        setCellHeaderProps: () => ({
          style: { justifyContent: "space-around", padding: "0px 12px" },
        }),
      },
    },
    {
      name: "nom_mission",
      label: "MISSION",
      options: {
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "100px",
            padding: "0px 12px",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
            maxWidth: "100px",
            padding: "2px 12px",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <Box data-toggle="tooltip" title={value}>
              <Link
                to={{
                  pathname: `/societe/${row.societeId}/missions/${row.missionId}/view`,
                }}
                className="d-print-none font-sm"
                style={{ textDecoration: "none" }}
              >
                {value}
              </Link>
            </Box>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "SOURCÉ",
      options: {
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "100px",
            textAlign: "center",
            padding: "0px 32px",
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
            justifyContent: "center",
            maxWidth: "100px",
            padding: "0px 32px",
          },
        }),
        customBodyRender: (value) => {
          return (
            <Box style={{ textAlign: "center" }}>
              {value ? moment(value).format("DD/MM/yyyy") : "-"}
            </Box>
          );
        },
      },
    },
    {
      name: "sent",
      label: "ENVOYE",
      options: {
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              <SendCandidatToClientModal
                {...{
                  reloadData,
                  setReloadData,
                  candidatName,
                  setAutresPieces,
                  missions: processes,
                  selectedMission: row.missionId,
                  sentDate:
                    value && value.date
                      ? moment(value.date).format("DD/MM/yyyy")
                      : "Envoyer",
                  candidatAccountManager,
                  candidatConsultant,
                  candidatSeniorite,
                  candidatCommentaire,
                  candidatPointFort,
                  candidatSoftskills,
                  candidatLangue2,
                  candidatAnglais,
                  candidatActuPackage,
                  candidatActuFixe,
                  candidatActuVariable,
                  candidatActuInteress,
                  candidatSouhaitePackage,
                  candidatsouhaiteFixe,
                  candidatsouhaiteVariable,
                  candidatsouhaiteInteress,
                  candidatpreAvis,
                  candidatdispoLe,
                  numCandidat,
                }}
                processId={row.processId}
                key={row.processId}
                isMissionActive={row.statut === "ACTIVE"}
              />
              {value ? (
                ""
              ) : (
                <>
                  {" | "}
                  <a
                    href="#/"
                    onClick={(e) => handleDeleteProcess(e, row.processId, row.numMission)}
                    style={{ textDecoration: "none", color: "red" }}
                  >
                    X
                  </a>
                </>
              )}
            </>
          );
        },
      },
    },
    {
      name: "revealed",
      label: "REVELE",
      options: {
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <SendCandidatToClientModal
              {...{
                reloadData,
                setReloadData,
                candidatName,
                setAutresPieces,
                missions: processes,
                selectedMission: row.missionId,
                sentDate:
                  row.sent && row.sent.date
                    ? moment(row.sent.date).format("DD/MM/yyyy")
                    : "",
                revealDate:
                  value && value.date
                    ? moment(value.date).format("DD/MM/yyyy")
                    : "Révéler",
                forReveal: true,
                countReveal: row.countReveal,
                numCandidat,
              }}
              key={row.processId}
              isMissionActive={row.statut === "ACTIVE"}
              {...{ candidatEmail, candidatTel, numCandidat }}
              processId={row.processId}
            />
          );
        },
      },
    },
    {
      name: "countReveal",
      label: "RELANCES",
      options: {
        display: false,
      },
    },
    {
      name: "step",
      label: "STEP",
      options: {
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              {
                <AppointmentsListModal
                  {...{
                    proces: row.processId,
                    status: value,
                    reloadProcess: setReloadData,
                    snackbarShowMessage,
                  }}
                />
              }
            </>
          );
        },
      },
    },

    {
      name: "lastAppointment",
      label: "DATE/STEP",
      options: {
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          const step = row.step;
          const processId = row.processId;
          const dateIntegration = row.dateIntegration;
          const isEmbauche = step === "Embauche/Integration";

          return (
              <Box style={{ display: 'flex', alignItems: 'center' }}>
              <span>
                {value
                    ? isEmbauche
                        ? moment(value).format("DD/MM/yyyy") +
                        "-" +
                        moment(dateIntegration).format("DD/MM/yyyy")
                        : moment(value).format("DD/MM/yyyy")
                    : "Aucun"}
              </span>
                {value && (
                    <IconButton
                        size="small"
                        data-toggle="tooltip"
                        title="Modifier la date d'intégration"
                        onClick={() => handleOpenDateModal(processId, value, dateIntegration, step)}
                        style={{ marginLeft: '4px', padding: '2px' }}
                    >
                      <Edit style={{ fontSize: '14px', color: 'rgb(17, 122, 167)' }} />
                    </IconButton>
                )}
              </Box>
          );
        },
      },
    },
    {
      name: "processId",
      label: "N° PROCESS",
      options: {
        display: false,
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
      },
    },
    {
      name: "societeId",
      label: "N° SOCIETE",
      options: {
        display: false,
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
      },
    },
    {
      name: "actions",
      label: "ACTIONS",
      options: {
        setCellHeaderProps: () => ({ style: { padding: "2px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              {row.status !== "PASSIVE" ? (
                <div className={ classes.actionContainer }>
                  {row.nom_mission ? (
                    <AppointmentModal
                      {...apptModalProps}
                      processId={row.processId}
                      lastAppointment={row.step}
                    />
                  ) : (
                    ""
                  )}
                  { !row.sent &&
                    <IconButton 
                      data-toggle="tooltip" 
                      title="Supprimer" 
                      aria-label="Supprimer" 
                      onClick={(e) => handleDeleteProcess(e, row.processId, row.numMission)}
                      style={{ color: "#EF6262" }}
                    >
                      <Delete />
                    </IconButton>
                  }
                </div>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    },
    {
      name: "dateIntegration",
      label: "dateIntegration",
      options: {
        display: false,
        setCellHeaderProps: () => ({ style: { padding: "0px 12px" } }),
        setCellProps: () => ({ style: { padding: "0px 12px" } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return <>{moment(value).format("DD/MM/yyyy")}</>;
        },
      },
    },
  ];

  const options = {
    serverSide: true,
    count: count,
    rowsPerPage: 50,
    tableBodyMaxHeight: "44vh",
    textLabels: {
      body: {
        noMatch: loading ? (
          <CircularProgress />
        ) : (
          "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment."
        ),
      },
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          handlePageChange(tableState.page);
          break;
        default:
      }
    },
    selectableRows: "none",
    draggableColumns: {
      enabled: true,
    },
    filter: false,
    filterType: "dropdown",
    responsive: "standard",
    print: false,
    columns: false,
    search: false,
    download: false,
    viewColumns: false,
  };

  const dialogAcheverProps = {
    handleClose: handleCloseFinishDialog,
    handleOpen: openFinishDialog,
    handleDelete: handleFinishMission,
    loading: loadingtoFinish,
    label: ` Voulez vous vraiment achever la mission: ${missionInfos.nom}?`,
    title: "Achever la mission",
  };

  const dialogDeleteProps = {
    handleClose: handleCloseDeleteDialog,
    handleOpen: openDeleteDialog,
    handleDelete: deleteProcessFromCandidat,
    loading: loadingToDelete,
    label: `Voulez vous supprimer le process: ${missionInfos.nom}?`,
    title: "Supprimer le process?",
  };

  return (
    <>
      <DialogDeleteCustom {...dialogAcheverProps} />
      <DialogDeleteCustom {...dialogDeleteProps} />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <MissionModal {...missionModalProps} />
        <Box>
          <label className="input-label" htmlFor="tachesTermines">
            MISSIONS PASSIVES
          </label>
          <FormControlLabel
            control={
              <Switch
                checked={missionPassive}
                onChange={(e) => setMissionPassive(e.target.checked)}
                name="missionPassives"
                color="primary"
              />
            }
            style={{ marginLeft: "0.2em", marginRight: 0 }}
          />
        </Box>
      </div>
      <MUIDataTable data={processes} columns={columns} options={options} />
      <Dialog
          open={dateModalOpen}
          onClose={handleCloseDateModal}
          maxWidth="xs"
          fullWidth
      >
        <DialogTitle style={{ color: 'rgb(17, 122, 167)' }}>
          Modifier la date
        </DialogTitle>
        <DialogContent>
          <label className="input-label">Date</label>
          <KeyboardDatePicker
              style={{ marginTop: "8px" }}
              invalidDateMessage="Date invalide"
              autoOk={true}
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              inputVariant="outlined"
              margin="normal"
              fullWidth
              value={selectedDate}
              onChange={(value) => setSelectedDate(value)}
          />
          {editingStep === "Embauche/Integration" && (
              <>
                <label className="input-label" style={{ marginTop: '12px', display: 'block' }}>
                  Date d'intégration
                </label>
                <KeyboardDatePicker
                    style={{ marginTop: "8px" }}
                    invalidDateMessage="Date invalide"
                    autoOk={true}
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    inputVariant="outlined"
                    margin="normal"
                    fullWidth
                    value={selectedDateIntegration}
                    onChange={(value) => setSelectedDateIntegration(value)}
                />
              </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDateModal} disabled={savingDate}>
            Annuler
          </Button>
          <Button
              onClick={handleSaveDateIntegration}
              disabled={savingDate}
              style={{ backgroundColor: 'rgb(66, 186, 150)', color: '#FFF' }}
          >
            Sauvegarder
            {savingDate && <CircularProgress size={16} style={{ color: 'white', marginLeft: '8px' }} />}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withSnackbar(Process);
